import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist' // https://www.npmjs.com/package/vuex-persist

import actions from './actions'
import state from './state'
import getters from './getters'
import mutations from './mutations'

Vue.use(Vuex);
const vuexPersist = new VuexPersist({
  key: 'smarterfinancial',
  storage: sessionStorage
})


// const vuexCookie = new VuexPersistence({
//   restoreState: (key, storage) => Cookies.getJSON(key),
//   saveState: (key, state, storage) =>
//     Cookies.set(key, state, {
//       expires: 3
//     }),
//   modules: ['user'], //only save user module
//   filter: (mutation) => mutation.type == 'logIn' || mutation.type == 'logOut'
// })

export const store = new Vuex.Store({
  create(){

  }, 
  plugins: [vuexPersist.plugin,],
  modules: {
    },
    state: {...state},
    mutations: { ...mutations },
    getters: { ... getters},
    actions: { ...actions }
  })